import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styles from './styles.module.css'
import { useVerifyOtpMutation } from '../../redux/users/usersApiSlice'
import { setCredentials } from '../../redux/auth/authSlice'

const OtpVerification = () => {
  const [otp, setOtp] = useState('')
  const [error, setError] = useState('')
  const [msg, setMsg] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const { phone } = location.state || {}
  const [verifyOtp] = useVerifyOtpMutation()
  const dispatch = useDispatch()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!phone) {
      setError('Phone number is missing.')
      return
    }
    try {
      const response = await verifyOtp({ phone, otp }).unwrap()
      // dispatch(setCredentials({ ...response, phone }))
      setMsg('OTP verified successfully.')
     navigate('/login')
    } catch (err) {
      setError(err.data?.message || 'Invalid OTP. Please try again.')
    }
  }

  return (
    <div className={styles.container}>
      <form className={styles.form_container} onSubmit={handleSubmit}>
        <h1>Verify OTP</h1>
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          required
          className={styles.input}
        />
        {error && <div className={styles.error_msg}>{error}</div>}
        {msg && <div className={styles.success_msg}>{msg}</div>}
        <button type="submit" className={styles.green_btn}>
          Verify OTP
        </button>
      </form>
    </div>
  )
}

export default OtpVerification
